module.exports = __webpack_public_path__ + "static/media/UltraTemp.17f9efbf.pdf";